import { Button, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { PimoReactComponent } from "@pimo/pimo-app-builder";
export const CustomButton: PimoReactComponent<{
  title: string;
  onClick: () => void;
  isActive: boolean;
}> = ({ title, onClick, isActive }) => {
  const theme = useTheme();
  return (
    <Box key={title}>
      <Button
        sx={{
          width: 150,
          px: 4,
          py: 2,
          borderRadius: "6px",
          border: "1px solid",
          height: "45px",
          borderColor: theme.palette.primary.dark,
          color: isActive ? "white" : theme.palette.primary.dark,
          backgroundColor: isActive ? theme.palette.primary.dark : "white",
          "&:hover": {
            color: theme.palette.primary.dark,
            backgroundColor: "whitesmoke",
          },
          "&:focus": {
            color: "white",
            backgroundColor: theme.palette.primary.dark,
          },
          fontWeight: 500,
          lineHeight: "20px",
          fontSize: "14px",
          textTransform: "none",
          textAlign: "center",
          verticalAlign: "middle",
        }}
        onClick={onClick}
      >
        {title}
      </Button>
    </Box>
  );
};
